import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { setProject } from "../../redux/session/sessionActions";
import { useGetProjects } from "../../service/ContentManager";

import { ProjectListPage } from "./ProjectListPage";
import { ProjectTypePage } from "./ProjectTypePage";
import { VideoPage } from "./VideoPage";

import { roles, projects as PROJECTS } from "../../constants";

const findTypeByName = typeName => PROJECTS.types.find(t => t.name === typeName)

export default function HomeContainer({ project, user }) {

	let dispatch = useDispatch()
	let [type, setType] = useState();
	let [intro, setIntro] = useState(true);
	let { projects } = useGetProjects();

	if (project) {
		return <Navigate to="/dashboard" />
	} else if (projects.length === 1) {
		return <VideoPage type={findTypeByName(projects[0].projectTypeName)} skip={() => dispatch(setProject(projects[0]))} />;
	} else if (intro && type) {
		return <VideoPage type={type} skip={() => setIntro(false)} />;
	} else if (roles.isSuperUser(user) || type) {
		return <ProjectListPage projects={projects} type={type} userRole={user.role} />;
	} else {
		return <ProjectTypePage projects={projects} filter={setType} setProject={p => dispatch(setProject(p))} />;
	}
}
